import React, { useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Modal } from "react-bootstrap";

import { ModalContext } from "../../context/modal";
import { authApi } from "../../services/api";
import { TOASTIFY_OPTIONS } from "../../style/global";
import { DefaultButton, MyModalBody, MyModalInput } from "../../style/default";

function ModalSectorEdit({ open, data, populateTable, clientName }) {
  const { handleOpenModal } = useContext(ModalContext);
  const [name, setName] = useState("");
  const [token, setToken] = useState("");
  const [expectedFlowrate, setExpectedFlowrate] = useState(0);
  const [id, setId] = useState("");

  //populate data
  useEffect(() => {
    if (data) {
      setName(data?.name);
      setId(data?._id);
      setToken(data?.token);
      setExpectedFlowrate(data?.expectedFlowrate);
    }
  }, [data]);

  const handleSectorEdit = async () => {
    if (!name) {
      toast.error("Insira um nome!", TOASTIFY_OPTIONS);
      return;
    }
    if (!token) {
      toast.error("Insira o token!", TOASTIFY_OPTIONS);
      return;
    }
    if (!expectedFlowrate) {
      toast.error("Insira a vazão diária!", TOASTIFY_OPTIONS);
      return;
    }
    if (!id) {
      toast.error(
        "Houve um erro! entre em contato com o desenvolvedor",
        TOASTIFY_OPTIONS
      );
      return;
    }
    try {
      const data = await authApi.post("/sector/edit", {
        id: id,
        name: name,
        expectedFlowrate: expectedFlowrate,
        token: token
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .replace(/[[\].!'@,><|#:$%¨//\\;&*()_+=]/g, "")
          .toLocaleLowerCase()
          .trim()
          .replace(/[\s]+/g, "-"),
      });
      if (data.status === 200) {
        clientName[0]("");
        clientName[1]({ label: "", value: "" });
        populateTable();
        handleOpenModal();
        toast.success("Setor editado com sucesso.", TOASTIFY_OPTIONS);
      }
    } catch (error) {
      toast.error(error.message, TOASTIFY_OPTIONS);
      handleOpenModal();
    }
  };

  return (
    <Modal show={open} onHide={handleOpenModal} size="lg" backdrop="static">
      <Modal.Header closeLabel="" closeButton>
        <Modal.Title>
          Edição do setor: {data?.name}{" "}
          {data?.accountName.length ? `(${data?.accountName})` : ""}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <MyModalBody>
          <label>Nome:</label>
          <MyModalInput
            name="name"
            placeholder="ex:TI"
            onChange={(e) => setName(e.target.value)}
            value={name}
          />
          <label>Token (minúsculo, sem espaços):</label>
          <MyModalInput
            type="name"
            placeholder={"ex: ti"}
            onChange={(e) => setToken(e.target.value)}
            value={token}
          />
          <label>Vazão esperada :</label>
          <MyModalInput
            type="number"
            placeholder={"Ex: 300"}
            onChange={(e) => setExpectedFlowrate(e.target.value)}
            value={expectedFlowrate}
          />
        </MyModalBody>
      </Modal.Body>
      <Modal.Footer>
        <DefaultButton onClick={handleSectorEdit}>Editar</DefaultButton>
      </Modal.Footer>
    </Modal>
  );
}

export { ModalSectorEdit };
